if (!document.__modularSiteMobileDrawerDelegated) {
  document.__modularSiteMobileDrawerDelegated = true;

  const drawerForToggle = (toggle) => {
    const drawerId = toggle.getAttribute('aria-controls');
    if (!drawerId) return null;
    const drawer = document.getElementById(drawerId);
    return drawer?.matches('dialog[data-mobile-drawer]') ? drawer : null;
  };
  const syncDrawerState = (drawer) => {
    const expanded = String(Boolean(drawer?.open));
    document.querySelectorAll('[data-menu-toggle][aria-controls]').forEach((toggle) => {
      if (toggle.getAttribute('aria-controls') === drawer?.id) toggle.setAttribute('aria-expanded', expanded);
    });
  };
  const openDrawer = (drawer) => {
    if (!drawer || drawer.open) return;
    try {
      drawer.showModal();
    } catch (error) {
      drawer.setAttribute('data-show-modal-failed', error?.name || 'Error');
      drawer.setAttribute('open', '');
    }
    syncDrawerState(drawer);
  };
  const closeDrawer = (drawer) => {
    if (!drawer) return;
    try {
      if (drawer.open && typeof drawer.close === 'function') drawer.close();
    } catch (error) {
      drawer.setAttribute('data-close-failed', error?.name || 'Error');
    }
    if (drawer.open) drawer.removeAttribute('open');
    syncDrawerState(drawer);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const drawer = drawerForToggle(toggle);
      if (drawer?.open) closeDrawer(drawer);
      else openDrawer(drawer);
      if (!drawer) toggle.setAttribute('aria-expanded', 'false');
      return;
    }
    const close = event.target.closest('[data-menu-close]');
    if (close) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDrawer(close.closest('dialog[data-mobile-drawer]'));
    }
  }, true);
  document.addEventListener('close', (event) => {
    if (event.target instanceof Element && event.target.matches('dialog[data-mobile-drawer]')) syncDrawerState(event.target);
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('dialog[data-mobile-drawer][open]').forEach(closeDrawer);
  });
}

if (!document.__globalStickyMenuInitialized) {
  document.__globalStickyMenuInitialized = true;
  const syncStickyMenus = () => {
    document.querySelectorAll('[data-sticky-menu]').forEach((header) => {
      const wrapper = header.closest('.shopify-section') || header;
      wrapper.dataset.stickyMenuWrapper = 'true';
      header.dataset.scrolled = String(window.scrollY > 0);
    });
  };
  syncStickyMenus();
  window.addEventListener('scroll', syncStickyMenus, { passive: true });
  document.addEventListener('shopify:section:load', syncStickyMenus);
}

document.querySelectorAll('[data-site-header]').forEach((siteHeader) => {
  if (siteHeader.hasAttribute('data-site-header-initialized')) return;
  siteHeader.setAttribute('data-site-header-initialized', '');

  const drawer = siteHeader.querySelector('[data-mobile-drawer]');
  const desktopBranchSelector = '.cs-header__desktop > ul > li:has(> ul)';
  const desktopBranchLinkSelector = `${desktopBranchSelector} > a`;
  const setDesktopMenuState = (item, expanded) => {
    if (!item?.matches(desktopBranchSelector)) return;
    item.toggleAttribute('data-menu-open', expanded);
    item.querySelector(':scope > a')?.setAttribute('aria-expanded', String(expanded));
  };
  const closeDesktopMenus = (except) => siteHeader.querySelectorAll(desktopBranchSelector).forEach((item) => {
    if (item !== except) setDesktopMenuState(item, false);
  });

  siteHeader.querySelectorAll(desktopBranchLinkSelector).forEach((link) => {
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    const item = link.parentElement;
    item.addEventListener('pointerenter', () => {
      if (matchMedia('(pointer:fine)').matches) {
        closeDesktopMenus(item);
        setDesktopMenuState(item, true);
      }
    });
    item.addEventListener('pointerleave', () => {
      if (matchMedia('(pointer:fine)').matches && !item.contains(document.activeElement)) setDesktopMenuState(item, false);
    });
  });

  drawer?.querySelectorAll('li:has(> ul)').forEach((item, index) => {
    const link = item.querySelector(':scope > a');
    const submenu = item.querySelector(':scope > ul');
    if (!link || !submenu) return;
    const submenuId = `${drawer.id}-submenu-${index + 1}`;
    submenu.id = submenuId;
    item.setAttribute('data-mobile-branch', '');
    const branchToggle = document.createElement('button');
    branchToggle.type = 'button';
    branchToggle.className = 'cs-mobile-menu__branch-toggle';
    branchToggle.setAttribute('aria-controls', submenuId);
    branchToggle.setAttribute('aria-expanded', 'false');
    branchToggle.setAttribute('aria-label', `Expand ${link.textContent.trim()}`);
    item.insertBefore(branchToggle, submenu);
    branchToggle.addEventListener('click', () => {
      const expanded = item.toggleAttribute('data-mobile-menu-open');
      branchToggle.setAttribute('aria-expanded', String(expanded));
      branchToggle.setAttribute('aria-label', `${expanded ? 'Collapse' : 'Expand'} ${link.textContent.trim()}`);
      if (expanded) item.scrollIntoView({ block: 'nearest' });
    });
  });

  siteHeader.addEventListener('click', (event) => {
    const parentLink = event.target.closest(desktopBranchLinkSelector);
    if (parentLink && matchMedia('(pointer:coarse)').matches) {
      const item = parentLink.parentElement;
      if (!item.hasAttribute('data-menu-open')) {
        event.preventDefault();
        closeDesktopMenus(item);
        setDesktopMenuState(item, true);
      }
    }
  });
  siteHeader.addEventListener('focusout', (event) => {
    const item = event.target.closest(desktopBranchSelector);
    if (!item || item.contains(event.relatedTarget)) return;
    setDesktopMenuState(item, false);
  });
  siteHeader.addEventListener('keydown', (event) => {
    const parentLink = event.target.closest(desktopBranchLinkSelector);
    if (parentLink && (event.key === ' ' || event.key === 'Spacebar')) {
      event.preventDefault();
      const item = parentLink.parentElement;
      const expanded = !item.hasAttribute('data-menu-open');
      closeDesktopMenus(expanded ? item : null);
      setDesktopMenuState(item, expanded);
      return;
    }
    if (parentLink && event.key === 'Enter' && !parentLink.parentElement.hasAttribute('data-menu-open')) {
      event.preventDefault();
      closeDesktopMenus(parentLink.parentElement);
      setDesktopMenuState(parentLink.parentElement, true);
      return;
    }
    if (event.key !== 'Escape') return;
    const item = event.target.closest(`${desktopBranchSelector}[data-menu-open]`);
    if (!item) return;
    event.preventDefault();
    event.stopPropagation();
    const link = item.querySelector(':scope > a');
    setDesktopMenuState(item, false);
    link?.focus();
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.cs-header__desktop')) closeDesktopMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeDesktopMenus();
  });
});
